// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__PtvMZ","name":"ConsentHeader_name__3MLB5","birthday":"ConsentHeader_birthday__2YF7y","skeleton":"ConsentHeader_skeleton__11Mld"};